import './resources.scss';
import queryString from 'query-string';
import { setUrl } from '../../../src/js/utils/setUrl';

const selectors: Record<'form' | 'filters', string> = {
  form: '[data-resources-form]',
  filters: '[data-resources-filter]',
};

const elements: Record<
  'form' | 'filters',
  null | HTMLElement | NodeListOf<HTMLElement>
> = {
  form: null,
  filters: null,
};

const checkActiveFilter = (filter: HTMLElement) => {
  const url = window.location.href;

  if (url.includes(filter.dataset.resourcesFilter as string)) {
    return filter.classList.add('active');
  }

  if (filter.dataset.resourcesFilter === '*' && !url.includes('?category')) {
    return filter.classList.add('active');
  }
};

function changeForm(e: Event) {
  e.preventDefault();

  const target = e.target as HTMLFormElement;

  const { name, value, type, label, checked } = target;

  if (value === '*') {
    // @ts-ignore
    return (window.location = queryString.exclude(window.location.href, [
      'region',
    ]));
  }

  setUrl({
    region: value,
  });
}

function init() {
  elements.form = document.querySelector(selectors.form) as HTMLElement;
  elements.filters = document.querySelectorAll(selectors.filters);

  elements.form?.addEventListener('change', changeForm);
  elements.filters?.forEach(checkActiveFilter);
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init();
  },
  { once: true }
);
